<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <img src="@/assets/logo.svg" alt="Logo" class="logo" />
        <h2 class="title">FanqianAI 管理后台</h2>
        <p class="subtitle">卡密验证系统管理平台</p>
      </div>
      
      <el-tabs v-model="activeTab" class="login-tabs">
        <el-tab-pane label="管理员登录" name="admin">
          <el-form
            ref="adminFormRef"
            :model="adminForm"
            :rules="loginRules"
            class="login-form"
            @keyup.enter="handleAdminLogin"
          >
            <el-form-item prop="username">
              <el-input
                v-model="adminForm.username"
                placeholder="请输入管理员用户名"
                prefix-icon="User"
                size="large"
              />
            </el-form-item>
            
            <el-form-item prop="password">
              <el-input
                v-model="adminForm.password"
                type="password"
                placeholder="请输入密码"
                prefix-icon="Lock"
                size="large"
                show-password
              />
            </el-form-item>
            
            <el-form-item>
              <el-button
                type="primary"
                size="large"
                class="login-button"
                :loading="loginLoading"
                @click="handleAdminLogin"
              >
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        
        <el-tab-pane label="代理商登录" name="agent">
          <el-form
            ref="agentFormRef"
            :model="agentForm"
            :rules="loginRules"
            class="login-form"
            @keyup.enter="handleAgentLogin"
          >
            <el-form-item prop="username">
              <el-input
                v-model="agentForm.username"
                placeholder="请输入代理商用户名"
                prefix-icon="User"
                size="large"
              />
            </el-form-item>
            
            <el-form-item prop="password">
              <el-input
                v-model="agentForm.password"
                type="password"
                placeholder="请输入密码"
                prefix-icon="Lock"
                size="large"
                show-password
              />
            </el-form-item>
            
            <el-form-item>
              <el-button
                type="primary"
                size="large"
                class="login-button"
                :loading="loginLoading"
                @click="handleAgentLogin"
              >
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      
      <div class="login-footer">
        <p>© 2025 FanqianAI. All rights reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'LoginPage',
  setup() {
    const store = useStore()
    const router = useRouter()
    
    const activeTab = ref('admin')
    const adminFormRef = ref()
    const agentFormRef = ref()
    
    const adminForm = reactive({
      username: '',
      password: ''
    })
    
    const agentForm = reactive({
      username: '',
      password: ''
    })
    
    const loginRules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        { min: 3, max: 50, message: '用户名长度在 3 到 50 个字符', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, max: 50, message: '密码长度在 6 到 50 个字符', trigger: 'blur' }
      ]
    }
    
    const loginLoading = computed(() => store.getters['auth/loginLoading'])
    
    const handleAdminLogin = async () => {
      if (!adminFormRef.value) return
      
      try {
        await adminFormRef.value.validate()
        
        await store.dispatch('auth/adminLogin', {
          username: adminForm.username,
          password: adminForm.password
        })
        
        ElMessage.success('登录成功')
        router.push('/dashboard')
        
      } catch (error) {
        console.error('管理员登录失败:', error)
      }
    }
    
    const handleAgentLogin = async () => {
      if (!agentFormRef.value) return
      
      try {
        await agentFormRef.value.validate()
        
        await store.dispatch('auth/agentLogin', {
          username: agentForm.username,
          password: agentForm.password
        })
        
        ElMessage.success('登录成功')
        router.push('/dashboard')
        
      } catch (error) {
        console.error('代理商登录失败:', error)
      }
    }
    
    return {
      activeTab,
      adminFormRef,
      agentFormRef,
      adminForm,
      agentForm,
      loginRules,
      loginLoading,
      handleAdminLogin,
      handleAgentLogin
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.login-header {
  text-align: center;
  padding: 40px 30px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  
  .logo {
    width: 60px;
    height: 60px;
    margin-bottom: 16px;
  }
  
  .title {
    margin: 0 0 8px;
    font-size: 24px;
    font-weight: 600;
  }
  
  .subtitle {
    margin: 0;
    font-size: 14px;
    opacity: 0.9;
  }
}

.login-tabs {
  padding: 30px;
  
  :deep(.el-tabs__header) {
    margin-bottom: 30px;
  }
  
  :deep(.el-tabs__nav-wrap::after) {
    display: none;
  }
}

.login-form {
  .el-form-item {
    margin-bottom: 24px;
  }
  
  .login-button {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-weight: 500;
  }
}

.login-footer {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  color: #6c757d;
  font-size: 12px;
}
</style>
